import React from 'react';

import {LoadingSpinner} from '@newsela/angelou';
import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

import {signInRoot} from 'static/three-oh/src/modules/constants/routePaths';

const LazySignIn = Loadable({
  loader: () => import(
    /* webpackChunkName: "SignIn" */
    './components/SignIn'
  ),
  loading: LoadingSpinner,
});

const SignInRoute = (
  <Route path={signInRoot} component={LazySignIn} />
);

export default SignInRoute;
